// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { AnalyticsQueries } from '../../../../types/server/modules/analytics/queries';

export type * from '../../../../types/server/modules/analytics/queries';

export const createQueries = ( requests: Requests ): AnalyticsQueries => ({
  UiWidgetLayoutsReadmodelById: ( id, query, headers ) => { 
          return requests.get( `/ui-widget-layouts-readmodel/${id}`, query, headers ); 
        },
  UiWidgetLayoutsReadmodel: ( params?, headers? ) => {
        return requests.get( `/ui-widget-layouts-readmodel/:id?`, params, headers );
      },
  ObservedOperationsReadmodelById: ( id, query, headers ) => { 
          return requests.get( `/observed-operations-readmodel/${id}`, query, headers ); 
        },
  ObservedOperationsReadmodel: ( params?, headers? ) => {
        return requests.get( `/observed-operations-readmodel/:id?`, params, headers );
      }
});
